import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

const ModalUploadPlotsExpenseForm = () => {
    const server_app_api_php = window.SERVER_APP_API_PHP;

    const [companyID] = useState(1); // Replace with actual companyID
    const [location] = useState(1);
    const [userID] = useState('');
  const [businessLocationOptions, setBusinessLocationOptions] = useState([]);
  const [expensesOptions, setExpensesOptions] = useState([]);
  const [formData, setFormData] = useState({
    business_locationIDExpensePlots: '',
    expensePlots: '',
    monthExpensePlots: '',
    yearExpensePlots: '',
    expenseAmountPlots: '',
  });

  let business_locationIDMain = localStorage.getItem('business_locationIDMain')
  if(business_locationIDMain === null){
    business_locationIDMain = '';
  }

  useEffect(() => {
    // Create formData object
    const formData = new FormData();
    formData.append("apiType", 'getBusinessLocationPlotsOnUploadForm');
    formData.append("companyID", window.userCompanyID);
    formData.append("location", business_locationIDMain);
    // Fetch plot options from the backend using POST method
    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        //console.log('What I receive From The server = ', response.data);
        setBusinessLocationOptions(response.data);
      })
      .catch(error => {
        //alert("There was an error fetching the Business Locations!", error);
      });
    }, []);

    useEffect(() => {
        // Create formData object
        const formData = new FormData();
        formData.append("apiType", 'getBusinessLocationExpensesOnUploadForm');
        formData.append("companyID", window.userCompanyID);
        formData.append("location", business_locationIDMain);
        // Fetch plot options from the backend using POST method
        axios.post(`${server_app_api_php}/server/index.php`, formData)
          .then(response => {
            setExpensesOptions(response.data);
          })
          .catch(error => {
            //alert("There was an error fetching the Business Location Expenses!", error);
          });

          //const currentYear = new Date().getFullYear();
          //const futureYears = Array.from({ length: 2100 - currentYear }, (_, i) => currentYear + i);
          //setYears(futureYears);
        }, []);


  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

 /* const handleSubmit = () => {
    const { business_locationIDExpensePlots, expensePlots, monthExpensePlots, yearExpensePlots, expenseAmountPlots } = formData;
    if (business_locationIDExpensePlots && expensePlots && monthExpensePlots && yearExpensePlots && expenseAmountPlots) {
      axios.post('upload.php', {
        ...formData,
        companyIDExpensePlots: companyID,
        userIDPlotExpenses: userID,
        apiType: 'uploadExpensesPlots',
      })
        .then(response => {
          alert(response.data);
          setFormData({
            business_locationIDExpensePlots: '',
            expensePlots: '',
            monthExpensePlots: '',
            yearExpensePlots: '',
            expenseAmountPlots: '',
          });
        })
        .catch(() => {
          alert('There seems to be a problem with your internet connectivity. If this problem continues, kindly contact the support team.');
        });
    } else {
      alert('Please fill all fields.');
    }
  };
*/

const handleSubmit = (e) => {
  e.preventDefault();
  
  const { business_locationIDExpensePlots, expensePlots, monthExpensePlots, yearExpensePlots, expenseAmountPlots } = formData;
  
  if (business_locationIDExpensePlots && expensePlots && monthExpensePlots && yearExpensePlots && expenseAmountPlots) {
      // Create a new FormData object
      const formDataToSend = new FormData();
      formDataToSend.append('business_locationIDExpensePlots', business_locationIDExpensePlots);
      formDataToSend.append('companyIDExpensePlots', companyID);
      formDataToSend.append('userIDPlotExpenses', userID);
      formDataToSend.append('expensePlots', expensePlots);
      formDataToSend.append('monthExpensePlots', monthExpensePlots);
      formDataToSend.append('yearExpensePlots', yearExpensePlots);
      formDataToSend.append('expenseAmountPlots', expenseAmountPlots);
      formDataToSend.append('apiType', 'uploadExpensesPlots');

      axios.post(`${server_app_api_php}/upload.php`, formDataToSend)
          .then(response => {
              alert(response.data);
              setFormData({
                  business_locationIDExpensePlots: '',
                  expensePlots: '',
                  monthExpensePlots: '',
                  yearExpensePlots: '',
                  expenseAmountPlots: '',
              });
          })
          .catch(() => {
              alert('There seems to be a problem with your internet connectivity. If this problem continues, kindly contact the support team.');
          });
  } else {
      alert('Please fill all fields.');
  }
};

  return (
    <>
    <Header />
    <hr />
    <div className="mt-5" id="modalUploadPlotsExpenseForm" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <p className="heading lead">Register Plots Expenses</p>
    
          </div>
          <div className="modal-body">
            {location && (
              <div className="row">
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="business_locationIDExpensePlots" value={formData.business_locationIDExpensePlots} onChange={handleInputChange} required>
                    <option value="">Choose Business Location..</option>
                    {businessLocationOptions.map((option) => (
                      <option key={option.businessLocationID} value={option.businessLocationID}>{option.businessLocationName}</option>
                    ))}
                  </select>
                </div>
                {  formData.business_locationIDExpensePlots != "" ? (
                  <>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="expensePlots" value={formData.expensePlots} onChange={handleInputChange} required>
                    <option value="">Choose Expense..</option>
                    {expensesOptions.map((option) => (
                      <option key={option.expensesID} value={option.expensesID}>{option.expenses}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="monthExpensePlots" value={formData.monthExpensePlots} onChange={handleInputChange} required>
                    <option value="">Choose Month..</option>
                    {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((month) => (
                      <option key={month} value={month}>{month}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-6 col-xl-6 col-md-12 md-form md-outline">
                  <select className="custom-select d-block w-100" id="yearExpensePlots" value={formData.yearExpensePlots} onChange={handleInputChange} required>
                    <option value="">Choose Year..</option>
                    {Array.from({ length: 77 }, (_, i) => 2023 + i).map((year) => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div className="col-lg-12 col-xl-12 col-md-12 md-form md-outline">
                  <div className="md-form md-outline">
                    <input type="text" id="expenseAmountPlots" className="form-control form-control-md" value={formData.expenseAmountPlots} onChange={handleInputChange} required />
                    <label htmlFor="expenseAmountPlots">Amount</label>
                  </div>
                </div>
                </>

                  ) : (<></>)

                  }

                <input type="hidden" id="companyIDExpensePlots" value={companyID} />
                <input type="hidden" id="userIDPlotExpenses" value={userID} />
                <div className="text-center mt-0">
                  <button className="btn btn-success" id="uploadExpensesPlots" onClick={handleSubmit}
disabled = {formData.business_locationIDExpensePlots === "" || formData.expensePlots === "" || formData.monthExpensePlots === "" || formData.yearExpensePlots === "" || formData.expenseAmountPlots === ""}
                  >Upload <i className="fas fa-pen-alt ml-1"></i></button>
                </div>
              </div>
            )}
          </div>
          <div className="modal-footer">
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ModalUploadPlotsExpenseForm;
